export default __webpack_public_path__ + "assets/document-component.c7d067f1.svg";